<template>
<div>
        <el-form :model="detailForm" label-width="105px">
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item label="项目名称">
                        <el-select
                        disabled
                        v-model="detailForm.projectId"
                        placeholder="请选择项目名称"
                        style="width: 100%"
                        @change="(value) => projectChange(value, 1)"
                        >
                            <el-option
                                v-for="item in projectList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="区域名称">
                        <el-select 
                        disabled
                        v-model="detailForm.areaId" placeholder="请选择区域名称" style="width: 100%">
                            <el-option
                                @change="(value) => areaChange(value, 1)"
                                v-for="item in areaList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item label="场馆类型">
                        <el-select  
                        disabled
                        v-model="detailForm.type" placeholder="请选择场馆类型" style="width: 100%">
                            <el-option
                                v-for="item in typeList"
                                :key="item.dictKey"
                                :label="item.dictValue"
                                :value="item.dictKey"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="场馆名称">
                        <el-select 
                        disabled
                        v-model="detailForm.venueId" placeholder="请选择活动区域">
                            <el-option
                                v-for="item in venueList"
                                :key="item.id" 
                                :label="item.name" 
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="16">
                    <el-form-item label="到场人数">
                        <el-input  
                        disabled
                        v-model="detailForm.attendance" placeholder="请选择活动区域">
                            <el-button 
                                @click="showUserListInfo"
                            slot="append">点击查看人员信息</el-button>
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="申请公司">
                        <el-input
                        disabled
                        v-model="detailForm.applyCompany" placeholder="请输入申请公司">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="申请人">
                        <el-input   
                        disabled
                        v-model="detailForm.applyName" placeholder="请输入申请人">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="证件号">
                        <el-input 
                        disabled
                        v-model="detailForm.applyCertNo" placeholder="请输入证件号">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="申请人手机">
                        <el-input 
                        disabled
                        v-model="detailForm.applyPhone" placeholder="请输入申请人手机">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="申请时间">
                        <el-input 
                        disabled
                        v-model="detailForm.createTime" placeholder="请输入申请时间">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="预定起期">
                        <el-input 
                        disabled
                        v-model="detailForm.startTime" placeholder="请输入预定起期">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="预定止期">
                        <el-input 
                        disabled
                        v-model="detailForm.endTime" placeholder="请输入预定止期">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="场馆租金(元)">
                        <el-input 
                        disabled
                        v-model="detailForm.venueAmount" placeholder="请输入场馆租金(元)">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="服务项">
                        <el-input 
                        disabled
                        v-model="serviceConfigNames" placeholder="请输入服务项">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="服务费总额(元)">
                        <el-input 
                        disabled
                        v-model="detailForm.serviceAmount" placeholder="请输入服务费总额(元)">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="费用总额(元)">
                        <el-input 
                        disabled
                        v-model="detailForm.totalAmount" placeholder="请输入费用总额(元)">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                    <el-form-item label="备注说明">
                        <el-input 
                        disabled
                        v-model="detailForm.description" placeholder="请输入备注说明">
                        </el-input>
                    </el-form-item>
            </el-row>
            <el-row>
                    <el-form-item label="审核说明">
                        <el-input 
                        disabled
                        v-model="detailForm.auditDescription" placeholder="请输入审核说明">
                        </el-input>
                    </el-form-item>
            </el-row>
            <el-row>
                    <el-form-item label="" label-width="0px">
                        <el-table
                            :data="tempConfigList"
                            border
                            style="width: 100%">
                            <el-table-column
                            fixed
                            type="index"
                            width="50">
                            </el-table-column>
                            <el-table-column
                            prop="projectName"
                            label="项目名称"
                            width="150">
                            </el-table-column>
                            <el-table-column
                            prop="chargeTypeName"
                            label="收费方式"
                            width="120">
                            </el-table-column>
                            <el-table-column
                            prop="name"
                            label="服务名称"
                            width="120">
                            </el-table-column>
                            <el-table-column
                            prop="fee"
                            label="服务费"
                            width="120">
                            </el-table-column>
                            <el-table-column
                            prop="description"
                            label="服务说明"
                            width="300">
                            </el-table-column>
                        </el-table>
                            <el-pagination
                            @size-change="handleConfigSizeChange"
                            @current-change="handleConfigCurrentChange"
                            :current-page="configPage.currentPage"
                            :page-sizes="[10]"
                            :page-size="configPage.size"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="configPage.total">
                            </el-pagination>
                    </el-form-item>
            </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align:center">
            <el-button type="primary" @click="handleRemoveApply">删 除</el-button>
            <el-button @click="$emit('detailClose','cancel')">关 闭</el-button>
        </div>
  <el-dialog title="人员信息" custom-class="add-dialog" v-if="dialogFormVisibleUser" :visible.sync="dialogFormVisibleUser" append-to-body>
    
            <el-form :model="userForm" ref="userForm" :rules="rules" label-width="105px">
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item required label="姓名" prop="name">
                            <el-input v-model="userForm.name" placeholder="请输入姓名">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item required label="电话" prop="phone">
                            <el-input v-model="userForm.phone" placeholder="请输入电话">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item label="证件号">
                            <el-input v-model="userForm.certNo" placeholder="请输入证件号">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="车牌号">
                            <el-input v-model="userForm.plateNo" placeholder="请输入车牌号">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="24"  style="text-align:center;">
                    <el-form-item label="" label-width="1px">
                        <el-button @click="addUser('userForm')" type="primary" size="small" icon="el-icon-plus">添加</el-button>
                    </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-form-item label="" label-width="5px">
                        <el-table
                        height="250"
                                :data="tempUserList"
                                border
                                style="width: 100%;">
                                </el-table-column>
                                <el-table-column
                                prop="name"
                                label="姓名"
                                width="100">
                                </el-table-column>
                                <el-table-column
                                prop="phone"
                                label="电话"
                                width="150">
                                </el-table-column>
                                <el-table-column
                                prop="certNo"
                                label="证件号"
                                width="">
                                </el-table-column>
                                <el-table-column
                                prop="plateNo"
                                label="车牌号"
                                width="">
                                </el-table-column>
                                <el-table-column
                                fixed="right"
                                label="操作"
                                width="100">
                                <template slot-scope="scope">
                                    <el-button @click="userDelActionClick(scope)" type="danger" size="small">删除</el-button>
                                </template>
                                </el-table-column>
                            </el-table>
                            <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="page.currentPage"
                            :page-sizes="[10]"
                            :page-size="page.size"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="page.total">
                            </el-pagination>
                    </el-form-item>
                </el-row>
            </el-form>
            
        <div slot="footer" class="dialog-footer" style="text-align:center;">
            <el-button @click="dialogFormVisibleUser = false">关闭</el-button>
        </div>
        </el-dialog>
    </div>
</template>

<script>
import {venueApplyRemove,getVenueApplyMember,addVenueApplyMember,removeVenueApplyMember,getVenueChargeTypeList} from '@/api/v4ward/stadium-management/apply';


export default {
    props:['dialogFormVisibleDetail','detailForm','projectList','areaList','typeList','venueList'],
    data(){
        return{
            page:{
                currentPage:1,
                size:10,
                total:0
            },
            configPage:{
                currentPage:1,
                size:10,
                total:0
            },
            tempConfigList:[],
            tempUserList:[],
            serviceConfig:[],
            venueChargeTypeList:[],
            serviceConfigNames:'',
            dialogFormVisibleUser:false,
            addUserList:[],
            userForm:{},
            
        rules: {
            name: [
                { required: true, message: '请输入活动名称', trigger: 'change' },
            ],
            phone: [
                { required: true, message: '请输入手机号', trigger: 'change' },
                { pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, message: '手机号格式错误' }
            ],
        },
        }
    },
    mounted(){
        console.log('<============mounted============>');
        let projectId = this.detailForm.projectId;
        let projectName = this.detailForm.projectName;
        let self = this;
        let ids = [];
        let serviceConfig = [];
        this.tempConfigList = [];
        this.serviceConfig = [];
        getVenueChargeTypeList().then(({data})=>{
            self.venueChargeTypeList = data;
            console.log();
            self.detailForm.applyCertNo = self.detailForm.applyCertNo||" ";
            self.detailForm.applyCompany = self.detailForm.applyCompany||" ";
            self.detailForm.auditDescription = self.detailForm.auditDescription||" ";
            self.detailForm.serviceConfigNames = self.detailForm.serviceConfigNames||" ";
            self.detailForm.description = self.detailForm.description||" ";
            self.detailForm.serviceConfig.forEach((ele,index)=>{
                let chargeTypeName = '';
                ele.projectId = projectId;
                ele.projectName = projectName;
                self.venueChargeTypeList.forEach((_ele)=>{
                    console.log(ele.chargeType,_ele.dictKey);
                    if(ele.chargeType==_ele.dictKey){
                        chargeTypeName = _ele.dictValue;
                    }
                });
                console.log(chargeTypeName);
                serviceConfig.push({
                    projectId:projectId,
                    projectName:projectName,
                    chargeTypeName:chargeTypeName,
                    name:ele.name,
                    fee:ele.fee,
                    description:ele.description
                })
                ids.push(ele.name);
            });
            console.log(serviceConfig);
            this.serviceConfig = serviceConfig;
                self.serviceConfigNames = ids.join(',');
                this.handleConfigPageAction();
        })
    },
    methods:{
        handleRemoveApply(){
            venueApplyRemove({ids:this.detailForm.id}).then((res)=>{
                console.log(res);
                this.$message.success('操作成功！')
                this.$emit('detailClose','remove')

            })
        },
        
        handleConfigPageAction(){
            let self = this;
            this.configPage.total = this.serviceConfig.length;
            let startIndex = (self.configPage.currentPage-1)*self.configPage.size;
            this.tempConfigList = this.serviceConfig.slice(startIndex,startIndex+self.configPage.size);
        },
        handleConfigCurrentChange(val){
            console.log(this.configPage);
            this.configPage.currentPage = val;
            this.handleConfigPageAction();
        },
        handleConfigSizeChange(val){
            console.log(this.configPage);
            this.configPage.size = val;
            this.handleConfigPageAction();
        },
        handleCurrentChange(val){
            console.log(this.page);
            this.page.currentPage = val;
            this.showUserListInfo();
        },
        handleSizeChange(val){
            console.log(this.page);
            this.page.size = val;
            this.showUserListInfo();
        },
        showUserListInfo(type){
            let self = this;
            // this.addUserList=[];
            this.tempUserList = [];
            this.userForm={};
            getVenueApplyMember({
                applyId:self.detailForm.id,
                current:self.page.currentPage,
                size:self.page.size
            }).then(({data})=>{
                this.tempUserList = data.records;
                this.addUserList = 
                // console.log(this.addUserList);
                // this.handlePageAction_();
                this.page.total = data.total;

            })
            this.dialogFormVisibleUser =true;
            setTimeout(()=>{

                this.$refs.userForm.clearValidate();
            });
        },
        
        userDelActionClick(row){
            console.log(row);
            // this.addUserList.splice(row.$index,1);
            this.$confirm(
                "<div>删除说明:</div>",
                "是否确定删除当前场馆?", 
                {
                dangerouslyUseHTMLString:true,
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
            .then(() => {
                return removeVenueApplyMember({ids:row.row.id})
            })
            .then(() => {
                    this.$message.success('操作成功!');
                    this.showUserListInfo();
                // this.onLoad();
                // this.$message.success('操作成功!');
                // this.$refs.crud.toggleSelection();
            });
        },
        
        checkAddUserRepeat(form){
            let repeatFlag = false;
            console.log(this.addUserList);
            this.addUserList.forEach((ele)=>{
                console.log(ele,form);
                console.log(form.phone&&(ele.phone === form.phone));
                console.log(form.certNo&&(form.certNo+''!=='undefined')&&(ele.certNo === form.certNo));
                console.log(form.plateNo&&(form.plateNo+''!=='undefined')&&(ele.plateNo === form.plateNo));
                if(form.phone&&(ele.phone === form.phone)){
                    repeatFlag = true;
                }
            });
            return repeatFlag;
        },
        addUser(formName){
            let self = this;
            // console.log(this.addUserList);
            this.$refs.userForm.validate((valid) => {
                if (valid) {
                        // self.addUserList.push({
                        //     name:self.userForm.name,
                        //     phone:self.userForm.phone,
                        //     certNo:self.userForm.certNo,
                        //     plateNo:self.userForm.plateNo
                        // });
                        addVenueApplyMember({
                            applyId:self.detailForm.id,
                            name:self.userForm.name,
                            phone:self.userForm.phone,
                            certNo:self.userForm.certNo,
                            plateNo:self.userForm.plateNo
                        }).then((res)=>{
                            console.log(res);
                            this.$message.success('操作成功!');
                            setTimeout(()=>{
                                self.showUserListInfo('add');
                                self.userForm = {};
                            })
                        })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
    ::v-deep .el-form{
        height: 60vh;
        overflow-y: scroll;
        overflow-x: hidden;
    }
</style>